export default class MimeTypeFromBase64 {
  static getFileMimeType(base64: string): string {
    // eslint-disable-next-line
    return base64.split(',')[0].match(/:(.*?);/)![1];
  }
}
